import {useQuery} from '@tanstack/react-query';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig, HTTP_REQUEST_HEADER} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';

/**
 * Binds the exam to the customer
 */
export const useBindExam = ({
    examToken,
    onFailure,
    onSuccess,
}: {
    examToken?: string;
    onSuccess: () => void;
    onFailure: () => void;
}) => {
    useQuery({
        enabled: Boolean(examToken),
        queryFn: () => {
            apiConfig.instanceGusaBackend
                .get(`${ENDPOINTS.BIND_EXAM}?token=${examToken}`, {
                    baseURL: apiConfig.API_URL,
                    headers: {
                        [HTTP_REQUEST_HEADER.AUTHORIZATION]: '',
                    },
                })
                .then(() => {
                    onSuccess();
                    return '';
                })
                .catch(error => {
                    onFailure();
                    logWithSentry(error, 'TYP CL - Error while trying to bind user account');
                    return '';
                });
        },
        queryKey: ['BIND_EXAM', examToken],
    });
};
